export default "__VITE_ASSET__MkACRn$H__"